<template>
  <div class="bg-white rounded-sm m-2">
    <AppModal v-model="showDetailsModal" xl6>
      <div v-if="application" class="p-4 bg-gray-50 h-full">
        <div class="flex gap-2 justify-end pb-2 mb-2 border-b border-gray-200" id="action-buttons">
          <button class="btn-query" @click="query">
            <i class="fa fa-question text-white mr-1"></i> Query
          </button>
          <button class="btn-approve" @click="showAreYouSure('approve')">
            <i class="fas fa-check-circle text-white mr-1"></i> Approve
          </button>
          <button class="btn-escalate" @click="assignPrompt">
            <i class="fa fa-hand-pointer text-blue mr-1"></i> Assign
          </button>
          <button class="btn-escalate" @click="replyPrompt" v-if="application && application.escalatedBy">
            <i class="fa fa-reply text-blue mr-1"></i> Reply
          </button>
        </div>
        <div class="h-full overflow-y-auto">
         {{application}}
        </div>
      </div>
    </AppModal>

    <AppModal v-model="showApproveConfirm" xl half>
      <div class="p-6">
        <div class="flex items-start mb-4">
          <div class="flex-shrink-0 w-12 h-12 rounded-full bg-green-100 flex items-center justify-center">
            <i class="fa fa-check-circle text-2xl text-green-600"></i>
          </div>
          <div class="ml-4 flex-1">
            <h3 class="text-xl font-bold text-gray-900 mb-2">Approve Application</h3>    
            <b-row class="mt-3">
              <b-col cols="4">
                <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full" @click="showApproveConfirm = false">
                  <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
              </b-col>
              <b-col cols="4"></b-col>
              <b-col cols="4">
                <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark" @click="showAreYouSure('approve')">
                  <i class="fa fa-check-circle text-white mr-1"></i> Approve</button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </AppModal>

    <AppModal v-model="areYouSure" xl half>
      <div class="p-6">
        <div class="flex items-start mb-4">
          <div class="ml-4 flex-1">
            <b-row>
              <b-col>
                <p class="text-sm">
                  <span class="h6">Are you sure you are ready to take this action?</span>.<br/>
                  This action can only be reversed by your superiors. Only confirm if you are certain that this is the appropriate Final Decision
                </p>
                <p class="mt-3 text-sm italic">
                  <b>Note:</b><br/>
                  All actions performed on <b class="text-blue">URSB eRegistry</b> are recorded and details of the account that initiated are tagged to the action.
                </p>
              </b-col>
            </b-row>
            <b-row class="mt-3">
              <b-col cols="4">
                <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full" @click="areYouSure = false">
                  <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
              </b-col>
              <b-col cols="4"></b-col>
              <b-col cols="4">
                <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark" @click="confirmedToExecuteNextAction">
                  <i class="fa fa-check-circle text-white mr-1"></i> Accept</button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </AppModal>

    <AppModal v-model="showQueryModal" xl half>
      <div class="p-6">
        <div class="mt-4">
          <label class="block text-sm font-semibold text-gray-700 mb-2">
            Query Message <span class="text-red-500">*</span>
          </label>
          <textarea
              v-model="queryMessage"
              rows="4"
              placeholder="Describe the query you want to raise on this application..."
              required
              class="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 resize-none"
          ></textarea>
        </div>
        <div class="flex gap-3 justify-end mt-6 pt-4 border-t border-gray-200">
          <button
              @click="showAreYouSure('query')"
              :disabled="!queryMessage.trim()"
              class="button bg-orange hover:bg-orange-dark text-white rounded-md p-2"
          >
            <i class="fa fa-paper-plane mr-2"></i> Query
            <span class="lds-ring" v-if="querying">
              <div></div><div></div><div></div><div></div>
            </span>
          </button>
        </div>
      </div>
    </AppModal>

    <b-modal id="modal-a-assign" hide-footer ref="assignSubmissions" title="Assign to Registrar">
      <Assignment :id="application ? (application.taskId || application.id) : null" type="nir-affiliations" permission="can_view_non_individual_affiliations_tasks"/>
    </b-modal>

    <b-modal id="modal-a-reply" hide-footer ref="replySubmissions" title="Reply to Escalation">
      <AssignmentReply :id="application ? (application.taskId || application.id) : null" :userId="application ? application.escalatedBy : null" type="nir-affiliations" />
    </b-modal>

    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
            <span class="title">Non Individual Affiliations Escalations</span>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="12">
        <div class="mx-auto">
          <b-progress value="100" v-if="loading"  variant="#007ac5" height="0.2rem" animated></b-progress>
        </div>
        <b-row>
          <b-col cols="12">
            <table class="min-w-full leading-normal">
              <thead>
              <tr class="border-b border-t border-grey">
                <th class="t-header">Tracking No.</th>
                <th class="t-header">Company Name</th>
                <th class="t-header">Type</th>
                <th class="t-header">Sub Type</th>
                <th class="t-header">Interim ERN</th>
                <th class="t-header text-center">Status</th>
                <th class="t-header text-center"> Date</th>
                <th class="t-header text-center">Submission Date</th>
                <th class="t-header text-center">Escalated By</th>
                <th class="t-header text-center">Action</th>
              </tr>
              </thead>

              <tbody>
              <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(submission, idx) in escalations" :key="idx">
                <td class="t-body text-blue font-bold">{{submission.trackingNumber}}</td>
                <td class="t-body font-bold">
                    {{submission.name}}
                </td>
                <td class="t-body text-xs">
                  <span >
                   {{submission.type ? submission.type.replaceAll("_", " ") : ''}}
                  </span>
                </td>
                <td class="t-body text-xs">{{submission.subType ? submission.subType.replaceAll("_", " ") : 'N/A'}}</td>
                <td class="t-body text-xs">{{submission.interimErn || 'N/A'}}</td>
                <td class="t-body text-center">
                  <span class="px-2 py-1 rounded text-xs font-bold" :class="submission.status === 'ESCALATED' ? 'bg-orange-100 text-orange-800' : 'bg-gray-100 text-gray-800'">
                    {{submission.status || 'N/A'}}
                  </span>
                </td>
                <td class="t-body text-center">
                  {{dateFormat(submission.createdAt)}}
                </td>
                <td class="t-body text-center">
                  {{submission.submittedAt ? dateTimeFormat(submission.submittedAt) : dateTimeFormat(submission.createdAt)}}
                </td>
                <td class="t-body text-center">
                  <span class="text-blue text-xs">{{submission.message || 'N/A'}}</span>
                </td>
                <td class="t-body">
                  <div class="flex">
                    <button @click="view(submission)" class="bg-blue px-2 py-1 text-white rounded-sm w-full">View</button>
                  </div>
                </td>
              </tr>
              <tr>
                <td v-if="escalations.length === 0" colspan="10" class="bg-inertgrey text-center py-1">
                  <span class="text-sm">No results found</span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="mx-1" v-if="pagination.totalPages > 1">
          <b-col cols="1">
            <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
          </b-col>
          <b-col cols="1">
            <b-row>
              <b-col cols="12">
                <p class="paginate-details text-center">
                  <b-badge class="bg-blue text-white">
                    {{currentPage}}/{{pagination.totalPages}}
                  </b-badge>
                </p>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="1" >
            <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
          </b-col>
          <b-col cols="6"></b-col>
          <b-col cols="1">
            <b-form-select v-model="limit" class="w-full text-xs form-select border-0 paginate-details" v-on:change="fetch">
              <b-select-option value="15">15</b-select-option>
              <b-select-option value="20">20</b-select-option>
              <b-select-option value="50">50</b-select-option>
              <b-select-option value="100">100</b-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <b-row>
              <b-col class="mx-auto">
                <p class="paginate-details text-center text-xs font-bold">
                  <span>{{((currentPage - 1) * limit) + 1}}</span> -
                  <span v-if="limit > escalations.length">{{pagination.totalElements}}</span>
                  <span v-else>{{currentPage * limit}}</span>
                  of {{pagination.totalElements}}
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import moment from "moment";
import {api} from "../../../../../app/services/api.service";
import AppModal from "../../non-individual/nir/components/AppModal.vue";
import Assignment from "@/views/home/commons/Assignment";
import AssignmentReply from "@/views/home/commons/AssignmentReply";

export default {
  name: "NonIndividualAffiliationsEscalations",
  components: { AppModal, Assignment, AssignmentReply },
  data(){
    return{
      showDetailsModal: false,
      showApproveConfirm: false,
      areYouSure: false,
      showQueryModal: false,
      pendingAction: null,
      queryMessage: '',
      querying: false,
      approving: false,
      selectedId:null,
      margin:"2px",
      hasContent:false,
      loading:true,
      message:null,
      currentPage:1,
      limit:15,
      application:null,
      escalations:[],
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      rows:{
        odd:"border-t border-grey hover:bg-header_grey",
        even:"border-t border-grey bg-header_grey"
      },
    }
  },
  mounted() {
    this.fetch()
  },
  methods:{
    ...mapActions(["fetchNonIndividualAffiliationsEscalations"]),
    cleanEntityType(name){
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    cleanString(name){
      let n = name.replaceAll("_", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    fetch(){
      let data = {
        status:"Pending",
        page:this.currentPage,
        limit:this.limit,
        userId : JSON.parse(sessionStorage.getItem("current_user")).userId
      }
      this.loading = true
      this.fetchNonIndividualAffiliationsEscalations(data)
    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetch()
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetch()
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
    view(submission){
      this.application = submission;
      this.showDetailsModal = true;
    },
    approve() {
      this.showApproveConfirm = true;
    },
    query() {
      this.queryMessage = '';
      this.showQueryModal = true;
    },
    assignPrompt() {
      this.$refs.assignSubmissions.show();
    },
    replyPrompt() {
      this.$refs.replySubmissions.show();
    },
    showAreYouSure(action) {
      this.pendingAction = action;
      this.areYouSure = true;
    },
    confirmedToExecuteNextAction() {
      this.areYouSure = false;
      if (this.pendingAction === 'approve') {
        this.confirmApprove();
      } else if (this.pendingAction === 'query') {
        this.confirmQuery();
      }
      this.pendingAction = null;
    },
    confirmApprove() {
      var self = this;
      this.showApproveConfirm = false;
      this.approving = true;
      api().post('/nir/api/v1/applications/approve', { applicationId: this.application ? (this.application.taskId || this.application.id) : null })
          .then(function () {
            self.approving = false;
            self.showDetailsModal = false;
            self.fetch();
          })
          .catch(function () {
            self.approving = false;
          });
    },
    async confirmQuery() {
      if (!this.application || !(this.application.taskId || this.application.id) || !this.queryMessage.trim()) return;
      var self = this;
      var senderId = null;
      try {
        const currentUser = JSON.parse(sessionStorage.getItem("current_user") || "{}");
        senderId = currentUser && currentUser.userId ? currentUser.userId : null;
      } catch (e) {
        senderId = null;
      }
      this.querying = true;
      var payload = {
        applicationId: this.application.taskId || this.application.id,
        message: this.queryMessage.trim(),
      };
      if (senderId) {
        payload.senderId = senderId;
      }
      api().post('/nir/api/v1/applications/query', payload)
          .then(function () {
            self.querying = false;
            self.queryMessage = '';
            self.showQueryModal = false;
            self.showDetailsModal = false;
            self.fetch();
          })
          .catch(function (error) {
            self.querying = false;
            const msg = (error && error.response && error.response.data && (error.response.data.message || error.response.data.error)) || 'Failed to send query. Please try again.';
            if (typeof self.errorToast === 'function') {
              self.errorToast('Query Error', msg);
            }
          });
    },
    checkForUpdates(){
      this.loading = true
      window.location.reload()
    },
    clearForm(){
      this.form = {
        description:null,
        reservationId:null,
        status:null
      }
    },
    dateFormat(date){
      if(date){
        return moment(date).format("DD-MM-YYYY")
      }
      return ""
    }
  },
  computed:{
    ...mapGetters([ "getNonIndividualAffiliationsEscalations", "getNonIndividualAffiliationsAssignmentSuccess", "getNonIndividualAffiliationsEscalationError"]),
  },
  watch:{
    getNonIndividualAffiliationsEscalations(res){
      console.log(res)
      this.loading = false
      if (res && res.data && res.data.content) {
        this.escalations = res.data.content
        this.pagination = {
          totalPages: res.data.pagination ? res.data.pagination.totalPages : 1,
          totalElements: res.data.pagination ? res.data.pagination.totalRows : (res.data.content.length || 0)
        }
      } else if (res && res.escalations) {
        this.escalations = res.escalations
        this.pagination = {
          totalPages: res.totalPages || 1,
          totalElements: res.totalElements || 0
        }
      } else {
        this.escalations = []
        this.pagination = { totalPages: 1, totalElements: 0 }
      }
    },
    getNonIndividualAffiliationsAssignmentSuccess(){
      this.$refs["escalate-details"].hide()
      this.fetch()
    },
      getNonIndividualAffiliationsEscalationError(error){
        this.errorToast("Failed !",error.message)
      }
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.icon{
  width: 170px;
}

.btn-escalate{
  @apply border border-blue bg-white rounded-sm text-blue text-sm px-3 py-1 mx-1;
}
.btn-escalate:hover{
  @apply text-blue-dark;
}
.btn-approve{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}
.btn-query{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}
.btn-approve:hover{
  @apply bg-green border-green text-white;
}
.btn-query:hover{
  @apply bg-orange border-orange text-white;
}

.view-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-blue text-blue text-xs w-full;
}

.view-btn:hover{
  @apply bg-blue text-white;
}

.approve-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-green text-green text-xs w-full;
}

.approve-btn:hover{
  @apply bg-green text-white;
}

.reject-btn{
  @apply px-3 py-1 bg-white border-2 border-red text-red font-bold text-xs w-full;
}

.reject-btn:hover{
  @apply bg-red text-white;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>